// extracted by mini-css-extract-plugin
export default {"container":"SideNavInputSearch_container__XxcrI","inputSearch":"SideNavInputSearch_inputSearch__td8bj","dataDisplay":"SideNavInputSearch_dataDisplay__RDQw9"};